import { render, staticRenderFns } from "./ReplaceKeysButton.vue?vue&type=template&id=2d1d7442&scoped=true&"
import script from "./ReplaceKeysButton.vue?vue&type=script&lang=js&"
export * from "./ReplaceKeysButton.vue?vue&type=script&lang=js&"
import style0 from "./ReplaceKeysButton.vue?vue&type=style&index=0&id=2d1d7442&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1d7442",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VIcon,VTab,VTabs})
